import React from 'react';
import { Table } from 'reactstrap';

/**
 * Config-driven results table — used for the Created/Invited/Errors
 * breakdowns shown after a submit, so each doesn't hand-write its own
 * near-identical <Table>.
 */
export const ResultsTable = ({ title, columns, rows }) => (
  <div className="mt-3">
    <h5>{title}</h5>
    <Table striped bordered size="sm">
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col.key}>{col.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>
            {columns.map((col) => (
              <td key={col.key}>{row[col.key]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);
